"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACKGROUND_UPLOAD_ERROR = exports.BACKGROUND_SCAN_FAILED_ERROR = void 0;
var BACKGROUND_UPLOAD_ERROR = exports.BACKGROUND_UPLOAD_ERROR = 'Background file failed to upload. Try Again';
var BACKGROUND_SCAN_FAILED_ERROR = exports.BACKGROUND_SCAN_FAILED_ERROR = 'Image file failed the security scan. Please upload a different image.';